const IMAGES = [];

/**
 * Returns the extracted meta information from a web assembly module that
 * Sentry uses to identify debug images.
 *
 * @param module
 */
function getModuleInfo(module) {
  const buildIds = WebAssembly.Module.customSections(module, 'build_id');
  let buildId = null;
  let debugFile = null;

  const buildId0 = buildIds[0];
  if (buildId0) {
    const firstBuildId = new Uint8Array(buildId0);
    buildId = Array.from(firstBuildId).reduce((acc, x) => {
      return acc + x.toString(16).padStart(2, '0');
    }, '');
  }

  const externalDebugInfo = WebAssembly.Module.customSections(module, 'external_debug_info');
  const externalDebugInfo0 = externalDebugInfo[0];
  if (externalDebugInfo0) {
    const firstExternalDebugInfo = new Uint8Array(externalDebugInfo0);
    const decoder = new TextDecoder('utf-8');
    debugFile = decoder.decode(firstExternalDebugInfo);
  }

  return { buildId, debugFile };
}

/**
 * Records a module
 */
function registerModule(module, url) {
  const { buildId, debugFile } = getModuleInfo(module);
  if (buildId) {
    const oldIdx = getImage(url);
    if (oldIdx >= 0) {
      IMAGES.splice(oldIdx, 1);
    }

    let debugFileUrl = null;
    if (debugFile) {
      try {
        debugFileUrl = new URL(debugFile, url).href;
      } catch (e) {
        // debugFile could be a blob URL which causes the URL constructor to throw
        // for now we just ignore this case
      }
    }

    IMAGES.push({
      type: 'wasm',
      code_id: buildId,
      code_file: url,
      debug_file: debugFileUrl,
      debug_id: `${buildId.padEnd(32, '0').slice(0, 32)}0`,
    });
  }
}

/**
 * Returns all known images.
 */
function getImages() {
  return IMAGES;
}

/**
 * Looks up an image by URL.
 *
 * @param url the URL of the WebAssembly module.
 */
function getImage(url) {
  return IMAGES.findIndex(image => {
    return image.type === 'wasm' && image.code_file === url;
  });
}

export { IMAGES, getImage, getImages, getModuleInfo, registerModule };
//# sourceMappingURL=registry.js.map
